import React from "react";
import SQLEditor from "../sql/editor/SQLEditor";

export default function SQLPlayground() {
  // Supabase Storage configuration
  const SUPABASE_BUCKET = "ecommerce_data";
  const DATASET_FILES = [
    "accounts.csv",
    "orders.csv",
    "region.csv",
    "sales_reps.csv",
    "web_events.csv"
  ];

  return (
    <div className="min-h-screen p-4 md:p-8 bg-gradient-to-br from-primary-dark to-primary">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-6 md:mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">SQL Playground</h1>
          <p className="text-sm md:text-base text-gray-200">
            Practice SQL queries with real e-commerce datasets. Click on a dataset to load it, then write your queries.
          </p>
        </div>
        <SQLEditor 
          supabaseBucket={SUPABASE_BUCKET}
          datasetFiles={DATASET_FILES}
        />
      </div>
    </div>
  );
}
